export class AcuseDTO {

    public fechaRecepcion!: string;
    public fechaRecepcionDT!: Date;
    public folioRecepcion!: string;
    public horaRecepcion!: string;
    public organoDestino!: string;
    public promovente!: string;
    public fechaEnvio!: string;
    public horaEnvio!: string;
    public folioEnvio!: string;
    public firmantesDoctos!: Firmantes[];
    public organoOrigen!: string;
    public autoridadEnvia!: string;
    public tipoAcuse!: TipoAcuseEnum;
    public numeroExpediente!: string;
    public tipoAsunto!: string;
    public boletaOCC!: string;

}


export class archivoEnviado {
    public id!: string;
    public name!: string;
    public size!: string;
    public noSerieCert!: string;

}

export class Firmantes {
    public signer!: string;
    public noSerieCert!: string;
    public documentos!: archivoEnviado[];
}


export enum TipoAcuseEnum {
    Demanda = 1,
    Promocion = 2,
    Notificacion = 3
}